// eslint-disable-next-line import/no-anonymous-default-export
export default {
  meEndpoint: '/auth/me',
  storageTokenKeyName: 'Marsool-admin-panel-web-accessToken',
  storageUserDataKeyName: 'Marsool-admin-panel-web-portal-userData'
}
